import { LanguageLoader } from "./loaders/LeguageLoader";
import Router from "./routes";
import "./styles/global.scss";

function App() {
  return (
    <LanguageLoader>
      <Router />
    </LanguageLoader>
  );
}

export default App;
